export default __webpack_public_path__ + "/src/assets/images/empty-graphic 1.svg";